interface IPeriodProps {
  children: React.ReactNode;
  UNSAFE_className?: string;
}

const Period: React.FC<IPeriodProps> = ({ children, UNSAFE_className }) => {
  return (
    <span
      className={`${UNSAFE_className} tw-lf-body-bold-sm tw-mb-2 desktop:tw-lf-body-bold-md`}
    >
      {children}
    </span>
  );
};

export default Period;
